import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Brand info reused everywhere
export const BRAND = {
  name: "Pro-pre Nettoyage Professionnel",
  shortName: "Pro-pre",
  domain: "www.pro-pre.com",
  url: "https://www.pro-pre.com",
  altDomains: ["www.pro-pre.fr", "pro-pre.com", "pro-pre.fr"],
  email: "contact@pro-pre.com",
  phone: "+32 466 13 28 39",
  whatsapp: "+32466132839",
  cities: "Bruxelles · Paris · Bergamo",
};
